import Gleap from 'gleap';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../router/routes';

const hideOnRoutes = [ROUTES.searchCompany, ROUTES.searchPeople];

export function useGleapVisibility() {
  const location = useLocation();

  useEffect(() => {
    const shouldHide = hideOnRoutes.some((route) =>
      location.pathname.startsWith(route)
    );

    if (shouldHide) {
      Gleap.showFeedbackButton(false);
    } else {
      Gleap.showFeedbackButton(true);
    }
  }, [location.pathname]);
}
